// /src/ui/primitives/Card.tsx
import React from "react";

export function Card(props: { children: React.ReactNode; className?: string }) {
  return (
    <div className={"rounded-xl2 border border-border bg-card shadow-soft " + (props.className || "")}>
      {props.children}
    </div>
  );
}

export function CardHeader(props: { title: string; subtitle?: string; right?: React.ReactNode }) {
  return (
    <div className="flex items-start justify-between gap-4 border-b border-border px-4 py-3">
      <div>
        <div className="text-sm font-semibold">{props.title}</div>
        {props.subtitle ? <div className="mt-0.5 text-xs text-muted">{props.subtitle}</div> : null}
      </div>
      {props.right ? <div className="shrink-0">{props.right}</div> : null}
    </div>
  );
}

export function CardBody(props: { children: React.ReactNode }) {
  return <div className="px-4 py-4">{props.children}</div>;
}
